var success = {
    token: 'MSWMOCK-eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIxMjM0IiwicHJvdmlkZXIiOiJ0ZXN0LXByb3ZpZGVyIiwicmVxdWVzdElkIjoiYTIzNTUwMzMtYmMwZi00ZGM4LWExNmYtYTg1NmYyNmY5Y2NkIiwiaWF0IjoxNzE0MDQxOTA5LCJleHAiOjE3MTM0NDAxNDEwMDB9.NUChRIwCNVZEen7Wy16ziV9EGYvg8y--145Et_qD1Ow',
};
export var tokenCreateMock = {
    success: success,
};
